import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { AI_AGENTS_ACTION_TYPE } from '../actions';

const initialState = {
  agents: [],
  templates: [],
};

const aiAgentsReducer = (state = initialState, { type, payload }) =>
  produce(state, draft => {
    switch (type) {
      case AI_AGENTS_ACTION_TYPE.GET_AI_AGENTS:
        draft.agents = payload;
        break;

      case AI_AGENTS_ACTION_TYPE.GET_AI_AGENT_TEMPLATES:
        draft.templates = payload;
        break;

      case AI_AGENTS_ACTION_TYPE.CREATE_AI_AGENT:
        draft.agents = [...state.agents, payload];
        break;

      case AI_AGENTS_ACTION_TYPE.UPDATE_AI_AGENT:
        draft.agents = state.agents.map(agent => (agent.id === payload.id ? payload : agent));
        break;

      case AI_AGENTS_ACTION_TYPE.DELETE_AI_AGENT:
        draft.agents = state.agents.filter(({ id }) => id !== payload);
        break;

      case AI_AGENTS_ACTION_TYPE.CLONE_AI_AGENT:
        draft.agents = [...state.agents, payload];
        break;

      case AI_AGENTS_ACTION_TYPE.ENABLE_AI_AGENT:
        draft.templates = state.templates.map(template =>
          template.id === payload ? { ...template, isEnabled: true } : template,
        );
        break;

      case AI_AGENTS_ACTION_TYPE.DISABLE_AI_AGENT:
        draft.templates = state.templates.map(template =>
          template.id === payload ? { ...template, isEnabled: false } : template,
        );
        break;

      case AI_AGENTS_ACTION_TYPE.RESET_AI_AGENTS_STATE:
      case RESET_STATE:
        return initialState;

      default:
        break;
    }
  });

export default aiAgentsReducer;
